/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class CoreModelKey {
  static readonly APPLICATION_ERROR = 'kit-core/model/application-error';
  static readonly VALIDATION_ERROR = 'kit-core/model/validation-error';
  static readonly MONTH = 'kit-core/model/month';
  static readonly WEEKDAY = 'kit-core/model/weekday';
}
